var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6663 2.00001H13.333C14.0663 2.00001 14.6663 2.6 14.6663 3.33334V14C14.6663 14.7333 14.0663 15.3333 13.333 15.3333H2.66634C1.93301 15.3333 1.33301 14.7333 1.33301 14V3.33334C1.33301 2.6 1.93301 2.00001 2.66634 2.00001H3.33301V1.33334C3.33301 0.966672 3.63301 0.666672 3.99967 0.666672C4.36634 0.666672 4.66634 0.966672 4.66634 1.33334V2.00001H11.333V1.33334C11.333 0.966672 11.633 0.666672 11.9997 0.666672C12.3663 0.666672 12.6663 0.966672 12.6663 1.33334V2.00001ZM3.33301 14H12.6663C13.033 14 13.333 13.7 13.333 13.3333V5.33334H2.66634V13.3333C2.66634 13.7 2.96634 14 3.33301 14Z",
    fill: "#2D87F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/CalendarBlue.03893ef4f91bf0e532c88a1fa629bf48.svg";
export { ForwardRef as ReactComponent };